import React from 'react'
import useFetch from './userFetch'
import {Link} from 'react-router-dom'
import { Container, Row, Col } from "react-bootstrap";
import './Notizie.css'

function Notizie() {
  //const{loading, error, data} = useFetch('http://localhost:1337/api/reviews')
  const{loading, error, data} = useFetch('../Home/backend/Admin/Articoli/reviews.json')

  if (loading) return <p>Loading...</p>
  if (error) return <p>Error :( </p>

  console.log(data)

  return (
    <section>
      <Container fluid className="home-section" id="notizie">
      
        <Container className="Notizie-content">
            <Row md={7} className="Notizie-header">
              <h1 style={{ paddingTop: 10 }}>
                NOTIZIE
              </h1>
            </Row>
        </Container>  
      </Container>
    

  <div>
      {data.data.map(review => (
        <div key={review.attributes.id} className="review-card">
          <div className="rating">{review.attributes.rating}</div>  
          <h2>{review.attributes.title}</h2>

          <small>Baes-Studio</small>
          {/*<p>{review.attributes.body.substring(0,200)}...</p>*/}
          <p>{review.attributes.body}</p>
          {/*<Link to={`/details/${review.attributes.id}`}>Leggimi..</Link>*/}
        </div>
      ))}

  </div>

  </section>
  );
}

export default Notizie;
